/** Stable machine-readable error codes. The client switches on these. */
export const ErrorCodes = {
    EVENT_IS_FREE: 'EVENT_IS_FREE',
    EVENT_NOT_FREE: 'EVENT_NOT_FREE',
    EVENT_NOT_LIVE: 'EVENT_NOT_LIVE',
    ANOTHER_EVENT_LIVE: 'ANOTHER_EVENT_LIVE',
    EVENT_ENDED: 'EVENT_ENDED',
    BAD_CODE: 'BAD_CODE',
    CODE_ALREADY_USED: 'CODE_ALREADY_USED',
    CALLSIGN_TAKEN: 'CALLSIGN_TAKEN',
    PLAYER_REMOVED: 'PLAYER_REMOVED',
    QUIZ_FULL: 'QUIZ_FULL',
    NOT_AUTHENTICATED: 'NOT_AUTHENTICATED',
    FORBIDDEN: 'FORBIDDEN',
    QUESTION_NOT_OPEN: 'QUESTION_NOT_OPEN',
    QUESTION_MISMATCH: 'QUESTION_MISMATCH',
    TOO_LATE: 'TOO_LATE',
    ALREADY_ANSWERED: 'ALREADY_ANSWERED',
    STALE_EXPECTATION: 'STALE_EXPECTATION',
    QUIZ_NOT_READY: 'QUIZ_NOT_READY',
    VALIDATION_FAILED: 'VALIDATION_FAILED',
    NOT_FOUND: 'NOT_FOUND',
    CHECKOUT_EXPIRED: 'CHECKOUT_EXPIRED',
    PAYMENT_FAILED: 'PAYMENT_FAILED',
    REFUND_TOO_LARGE: 'REFUND_TOO_LARGE',
    ROUND_TOO_SHORT: 'ROUND_TOO_SHORT',
    TOO_MANY_REQUESTS: 'TOO_MANY_REQUESTS',
    QUIZ_IN_SESSION: 'QUIZ_IN_SESSION',
    EVENT_NOT_OPEN: 'EVENT_NOT_OPEN',
};
/** Max concurrent players. 75 phones is the stated ceiling for one venue. */
export const MAX_PLAYERS = 75;
//# sourceMappingURL=errors.js.map